import { observer, useLocalObservable } from 'mobx-react-lite';
import { Box } from '@mui/material';
import './scss/create-group.style.scss';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import { CustomerLoading } from '../../component/loading/loading';
import { GroupState } from './group-management-state';
import DialogComponent from '../../component/dialog/dialog.component';
import GroupAccount from './group-info/group-account';
import { GroupAccountState } from './group-info/group-account-state';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { groupUnitData } from './group-unit';

/**
 * 新建集团弹窗内容
 */
const CreateGroupDialog = observer(({ useGroupData }: { useGroupData: GroupState }) => {

    useTranslation()
    // 解构数据
    const { isLoading, isOpenDialog } = useGroupData;

    // 集团账号新增数据管理
    const useGroupAccountData = useLocalObservable(() => new GroupAccountState({
        componentType: 'ADD',
    }));

    useEffect(() => {
        if (isOpenDialog) {
            useGroupAccountData.init();
        }
    }, [isOpenDialog])

    // *********************
    // View
    // *********************
    return (
        <DialogComponent
            fullWidth
            defaultHeaderProps={{
                title: i18n.t('create_group_component_text_create_group'),
                rightNode: (
                    <>
                        <ButtonComponent
                            size='small'
                            variant={'outlined'}
                            titleText={`${i18n.t('general_text_save')}`}
                            buttonStyle={{
                                marginRight: 10
                            }}
                            action={'SAVE'}
                            handleClick={async () => {
                                /**
                                 * 1. 新建集团
                                 * 2. 关闭弹窗
                                 * 3. 获取集团列表数据
                                 */
                                // 开启加载
                                useGroupData.load();
                                // 新建一个集团数据  关闭弹窗  错误标识errorFlag 成功后跳转集团页面
                                const { successFlag, group } = await useGroupAccountData.onSave('ADD');
                                // 关闭加载
                                useGroupData.loaded();
                                // 请求成功关闭弹窗
                                if (successFlag) {
                                    // 清空表单随后刷新数据
                                    useGroupAccountData.initGroupData();
                                    // 关闭弹窗
                                    useGroupData.closeAddGroupDialog();
                                    // 成功后刷新数据
                                    await useGroupData.getGroupListData();
                                    // 跳转集团页面
                                    useGroupData.showUnit = true;
                                    useGroupData.enterGroupDetailObj.groupData = group;
                                    groupUnitData.updateGroupId(group);
                                    groupUnitData.updatePanel(0);
                                }
                            }}
                        />
                        <ButtonComponent
                            size='small'
                            variant={'outlined'}
                            titleText={`${i18n.t('general_text_save_and_update')}`}
                            handleClick={async () => {
                                /**
                                 * 1. 新增后刷新表单数据 批量新增
                                 * 2. 不关闭弹窗
                                 */
                                // 开启加载
                                useGroupData.load();
                                // TODO 保存集团表单数据并新建一个集团数据 不关闭弹窗 $ 批量新增
                                const { successFlag } = await useGroupAccountData.onSave('ADD');
                                // 关闭加载
                                useGroupData.loaded();
                                if (successFlag) {
                                    // 清空表单随后刷新数据
                                    useGroupAccountData.initGroupData();
                                    // 成功后刷新数据
                                    await useGroupData.getGroupListData();
                                }
                            }}
                        >
                            <LibraryAddIcon />
                        </ButtonComponent>
                    </>
                )
            }}
            maxWidth={'xl'}
            open={isOpenDialog}
            onClose={() => {
                // 关闭弹窗
                useGroupData.closeAddGroupDialog();
                // 清空表单
                useGroupAccountData.initGroupData();
            }}
            transitionDuration={{
                appear: 450,
                enter: 400,
                exit: 300
            }}
            footer={<></>}
        >
            {/* 新增弹窗内容 TODO 待补充 */}
            <Box className='createGroup-modal'>
                {
                    isLoading &&
                    <CustomerLoading />
                }
                {/* 集团账号视图 */}
                <GroupAccount componentType='ADD' useGroupAccountMobx={useGroupAccountData} />
            </Box>
        </DialogComponent>
    )
})

export default CreateGroupDialog;

